import React from 'react';
import Layout from '../../components/Layout';
import { getUserInfo } from '../../user';
import { Navigate } from 'react-router-dom';
import StudyTypeTable from '../../components/StudyTypeTable';

export default function StudyTypes() {
  const [user, setUser] = React.useState(null);
  React.useEffect(() => {
    getUserInfo().then(setUser);
  }, []);
  if (!user) return null;
  if (!Array.isArray(user.roles) || !user.roles.includes('admin')) return <Navigate to="/" replace />;
  return (
    <Layout>
      <h1 className="text-2xl font-bold mb-4">Study Types</h1>
      <StudyTypeTable />
    </Layout>
  );
}
